import { useState, useEffect } from "react";
import React from 'react';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { createTheme } from '@mui/material/styles';
import { Header } from '../NavigationBar';
import { SideMenu } from '../NavigationBar';
import { loginRequest } from '../../authConfig';

const rtlTheme = createTheme({
  direction: 'rtl',
});

const ComponentA = ({ children }) => {
  return (
    <Box sx={{
      width: '80%',
      height: '100%',
      flexGrow: 1,
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center'
    }}>
      <Box sx={{
        width: '100%',
        height: '100%',
        paddingTop: '64px',
      }}>
        <Box sx={{
          width: '100%',
          '& > *': {
            width: '100%',
            margin: 0,
            padding: 0
          }
        }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export const PageLayout = ({ children }) => {
  const [openMenu, setOpenMenu] = useState(true);
  const [hasAttemptedLogin, setHasAttemptedLogin] = useState(false);
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    const justLoggedOut = sessionStorage.getItem('justLoggedOut');
    
    if (justLoggedOut) {
      sessionStorage.removeItem('justLoggedOut');
      setHasAttemptedLogin(true);
      return;
    }

    if (!isAuthenticated && accounts.length === 0 && inProgress === "none" && !hasAttemptedLogin) {
      setHasAttemptedLogin(true);
      instance.loginRedirect({
        ...loginRequest,
        prompt: "select_account"
      }).catch(e => {
        console.error("Login redirect failed:", e);
        setHasAttemptedLogin(false);
      });
    }
  }, [isAuthenticated, accounts.length, inProgress, instance, hasAttemptedLogin]);

  if (inProgress === "login" || inProgress === "handleRedirect" || inProgress === "startup") {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6">מתחבר למערכת...</Typography>
      </Box>
    );
  }

  if (!isAuthenticated || accounts.length === 0) {
    if (!hasAttemptedLogin) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            gap: 2
          }}
        >
          <CircularProgress size={60} />
          <Typography variant="h6">מפנה להתחברות...</Typography>
        </Box>
      );
    }
    
    return null;
  }

  return (
    <Stack
      direction="column"
      sx={{
        width: '100%',
        height: '100vh',
      }}
      spacing={0}
    >
      <Header openMenu={openMenu} setOpenMenu={setOpenMenu} />
      <Stack
        direction="row"
        spacing={0}
        sx={{
          flexGrow: 1,
          width: '100%',
        }}
      >
        {openMenu && <SideMenu openMenu={openMenu} setOpenMenu={setOpenMenu} />}
        <ComponentA children={children} />
      </Stack>
    </Stack>
  );
};